import { createOvermind, IConfig } from 'overmind'
import { namespaced } from 'overmind/config'
import { createHook, createStateHook } from 'overmind-react'

import * as rates from './rates'
import * as app from './app'

export const config = namespaced({
  rates,
  app,
})

export const overmind = createOvermind(config, { devtools: true })

export const useOvermind = createHook<typeof config>()
export const useOvermindState = createStateHook<typeof config>()

declare module 'overmind' {
  interface Config extends IConfig<typeof config> {}
}
